module.exports = __webpack_public_path__ + "img/menulingua_logomark_v2-02.a68464b6.svg";